// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-module--content--2myuE","main":"layout-module--main--1oOeP"};